import { render, staticRenderFns } from "./dictionaryList.vue?vue&type=template&id=0e6ed6f1&scoped=true&"
import script from "./dictionaryList.vue?vue&type=script&lang=js&"
export * from "./dictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryList.vue?vue&type=style&index=0&id=0e6ed6f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ed6f1",
  null
  
)

export default component.exports